import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useTranslation } from 'react-i18next';
import { DOC_MESSAGE } from '../config/constant';

const ReviewInput = ({ text, name, onView, disabled = false, boxWidth = "100%", justifyContent = "space-between", isPhysicalDoc = false,isKycPagePhysicalSubmited=false, documentNumber }) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: justifyContent,
        width: boxWidth,
        height:'100%'
      }}
    >
      {text.includes(":") ? (
        <Typography
          sx={{ fontSize: "14px", width: isPhysicalDoc ? "100%" : "75%" }}
        >
          <span style={{ fontWeight: 400 }}>{text.split(":")[0]}:</span> &nbsp;
          <span style={{ fontWeight: isPhysicalDoc ? 500 : 600 }}>
            {isPhysicalDoc && !isKycPagePhysicalSubmited ? `${DOC_MESSAGE}` : text.split(":")[1]}
          </span>
          <br/>
          {isKycPagePhysicalSubmited && <span style={{ fontWeight: 500 }}>{DOC_MESSAGE}</span>}
        </Typography>
      ) : (
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 500,
            width: isPhysicalDoc ? "100%" : "75%",
          }}
          title={
            isPhysicalDoc
              ? `${text}: ${DOC_MESSAGE}`
              : documentNumber
              ? `${text}: ${documentNumber}`
              : text
          }
        >
          {isPhysicalDoc ? (
            <>
              <Typography
                component="span"
                sx={{ fontSize: "14px", fontWeight: "400" }}
              >
                {text}:
              </Typography>
              <Typography
                component="span"
                sx={{ fontSize: "14px", fontWeight: "600" }}
                marginLeft={2}
              >
                {isKycPagePhysicalSubmited && <br />}
                {DOC_MESSAGE}
              </Typography>
            </>
          ) : (
            <>
              <Typography
                component="span"
                sx={{ fontSize: "14px", fontWeight: 400 }}
              >
                {text}:
              </Typography>

              {documentNumber && (
                <Typography
                  component="span"
                  sx={{ fontSize: "14px", fontWeight: 600 }}
                  marginLeft={2}
                >
                  {documentNumber}
                </Typography>
              )}
            </>
          )}
        </Typography>
      )}

      {!isPhysicalDoc && (
        <Button
          startIcon={<VisibilityIcon sx={{ color: !disabled && "#1A407D" }} />}
          size="large"
          sx={{
            textTransform: "none",
            color: "#1A407D",
            fontWeight: 400,
            fontSize: "14px",
            border: `1px solid ${disabled ? "#BDBDBD" : "#1A407D"}`,
            borderRadius: "8px",
            px: 2,
          }}
          onClick={() => onView(name)}
          disabled={disabled}
        >
          {t("button.view")}
        </Button>
      )}
    </Box>
  );
}

export default ReviewInput